<template>
  <div class="l-score-sum" @click="playAudio">
    <div class="l-score">
      <h3>{{right}} / {{ total }}</h3>
      <p>
        <span>正确</span>
        <span>总数</span>
      </p>
    </div>
    <div class="stars">
      <img v-for="i in star" :key="i" src="@/assets/images/good.png" class="good">
    </div>

    <!-- 预加载音频 -->
    <audio ref="audio" src="@/assets/audio/unbelievable.mp3" preload="auto" style="display: none;"></audio>
    <audio ref="audio" src="@/assets/audio/great-job.mp3" preload="auto" style="display: none;"></audio>
    <audio ref="audio" src="@/assets/audio/well-done.mp3" preload="auto" style="display: none;"></audio>
  </div>
</template>

<script>
import audioGreatJob from '@/assets/audio/great-job.mp3'
import audioUnbelievable from '@/assets/audio/unbelievable.mp3'
import audioWellDone from '@/assets/audio/well-done.mp3'

export default {
  props: {
    right: [Number],
    total: [Number],
  },
  data() {
    return {
      audio: null
    }
  },
  computed: {
    star() {
      if (this.right / this.total >= 0.92) {
        return 5
      } else if (this.right / this.total >= 0.8) {
        return 4
      } else if (this.right / this.total >= 0.6) {
        return 3
      } else if (this.right / this.total >= 0.4) {
        return 2
      } else if (this.right / this.total > 0) {
        return 1
      } else {
        return 0
      }
    },
    audioSrc() {
      if (this.star === 5) {
        return audioUnbelievable
      } else if (this.star === 4) {
        return audioGreatJob
      } else if (this.star === 3) {
        return audioWellDone
      }
      return null
    }
  },
  watch: {
    audioSrc(newVal) {
      if (newVal) {
        this.audio = new Audio(newVal);
        this.playAudio();
      }
    }
  },
  methods: {
    playAudio() {
      if (this.audio) {
        this.audio.currentTime = 0;
        this.audio.play().catch(error => {
          console.warn('音频播放失败:', error);
        });
      }
    }
  },
  beforeDestroy() {
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  },
}
</script>

<style lang="stylus" scoped>
.l-score-sum
  display flex
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
.l-score
  display inline-flex
  flex-direction column
  h3, p
    display inline-flex
    justify-content space-between
    align-items center
  h3
    margin 0
    padding 0
    color #01FCFA
    font-size 36px
  p
    font-size 14px
    color 0
    padding 0
    margin 0
    span
      scale 0.8

.stars {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
}
.good {
  width: 48px;
  height: 48px;
}
</style>